import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import toast from "react-hot-toast";
import PaymentLoadingModal from "../../../Components/Common/Model/PaymentLoadingModal";
import ConfirmCancelModal from "../../../Components/Utility/ConfirmCancelModal";
import ExperienceMap from "../../../Components/Utility/ExperienceMap";
import {
  BookingSkeleton,
  BoxSkeleton,
  ImageSkeleton,
} from "../../../Components/Utility/Skeletons";
import { SetMetaTags } from "../../../Components/Utility/setMetaTags";

function HostExperienceDetail() {
  const { booking_id } = useParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [baseUrl, setBaseUrl] = useState("");
  const [error, setError] = useState(null);
  
  const [isCancelling, setIsCancelling] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

 

 

  const handleCancellationRequest = async () => {
    setShowConfirm(true);
  };
  const handleConfirmCancel = async (cancel_reason = "No reason provided") => {
    setShowConfirm(false);
    if (isCancelling || !booking) return;

    try {
      setIsCancelling(true);
      const token = localStorage.getItem("authToken");

      let endpoint = "";

      // 🟢 Determine API endpoint based on cancel_status & cancel_by
      if (booking.cancel_status === null) {
        // Host requests cancellation
        endpoint = `${
          process.env.REACT_APP_API_BASE
        }/host/cancel-booking-request/${
          booking.booking_id
        }?cancel_reason=${encodeURIComponent(cancel_reason)}`;
      } else if (booking.cancel_status === 0 && booking.cancel_by === 1) {
        // User already requested → Host confirms cancellation
        endpoint = `${process.env.REACT_APP_API_BASE}/host/confirm-cancellation-request/${booking.booking_id}`;
      } else {
        toast.error("No further cancellation action available.");
        return;
      }

      const res = await axios.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data?.status) {
        toast.success(
          booking.cancel_status === null
            ? "Cancellation request sent successfully."
            : "Booking cancelled successfully."
        );

        // ✅ Refresh booking data to reflect new cancel status
        fetchBookingDetails();
      } else {
        toast.error(res.data?.message || "Action failed. Please try again.");
      }
    } catch (err) {
      // console.error("Cancellation error:", err);
      // toast.error("Something went wrong while processing the request.");
      const apiMessage =
        err.response?.data?.message ||
        "Something went wrong while processing the request.";
      toast.error(apiMessage);
    } finally {
      setIsCancelling(false);
    }
  };

  const fetchBookingDetails = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/booking-details/${booking_id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data?.status) {
        setBooking(res.data.data);
        setBaseUrl(res.data.base_url); // ✅ store base url
      } else setError("Booking details not found.");
    } catch (err) {
      console.error(err);
      setError("Failed to fetch booking details.");
    } finally {
      setLoading(false);
    }
  };

  

  useEffect(() => {
    if (booking_id) {
      fetchBookingDetails();
     
    }
  }, [booking_id]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const navigate = useNavigate();

  const formatTimeTo12Hour = (time24) => {
    if (!time24) return "";
    const [hours, minutes] = time24.split(":");
    const hour = parseInt(hours, 10);
    const suffix = hour >= 12 ? "PM" : "AM";
    const hour12 = ((hour + 11) % 12) + 1;
    return `${hour12}:${minutes} ${suffix}`;
  };

  const handleMessageClick = async () => {
    const hostData = {
      user_id: booking?.user_id,
      first_name: booking?.user_first_name,
      last_name: booking?.user_last_name,
      email: booking?.email,
      profile_image: booking?.host_profile_pic,
    };
    navigate("/message", { state: { chatTarget: hostData } });
  };

  // Helper function to format the URL
  const getExperienceUrl = (url_slug) => {
    return `/experience/${url_slug}`;
  };

  if (loading) {
    return (
      <section className="ser_v_araeea host_expert checkout user_allls pt-4">
        
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <BookingSkeleton height="150px" />
              <ImageSkeleton height="300px" />
            </div>
            <div className="col-lg-6">
              <BoxSkeleton height="250px" />
            </div>
            <div className="col-lg-12 mt-4">
              <ImageSkeleton height="300px" />
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error) return <p className="text-center py-4 text-red-600">{error}</p>;
  if (!booking) return <p className="text-center py-4">No booking found.</p>;

  return (
    <>
      {/* <!-- Booking Detail for host --> */}
      <section className="ser_v_araeea host_expert checkout user_allls pt-4">

         <SetMetaTags
        title= {booking.experience_title || "Experience | Weyfarin"}
        description=""
        keywords=""
      />
        <div className="containerdfgdf">
          {/* <div className="bedcramss">Dashboard &gt; Booking detail</div> */}

          <div className="top_bk_areaa host_exce_dtls checkout user_allls">
            <h4>Your Booking has been completed.</h4>
            <p>
              Booking ID : <span>{booking.booking_id}</span>
            </p>

            <div class="contxt_tx_bx othreenss messeg">
              {booking?.exp_cancel_status !== 2 && (
                <div className="cancel_div">
                  {booking?.cancel_status === null && (
                    <button
                      className="cancel_button"
                      onClick={handleCancellationRequest}
                      disabled={isCancelling}
                    >
                      {isCancelling
                        ? "Cancelling..."
                        : "Request for Cancellation"}
                    </button>
                  )}

                  {booking?.cancel_status === 0 && booking?.cancel_by === 2 && (
                    <button className="cancel_button status_pending" disabled>
                      Pending
                    </button>
                  )}

                  {booking?.cancel_status === 0 && booking?.cancel_by === 1 && (
                    <button
                      className="cancel_button"
                      onClick={handleCancellationRequest}
                      disabled={isCancelling}
                    >
                      {isCancelling ? "Cancelling..." : "Cancel Booking"}
                    </button>
                  )}

                  {booking?.cancel_status === 1 && (
                    <button className="cancel_button status_approve" disabled>
                      Booking Cancelled
                    </button>
                  )}
                </div>
              )}

              <span>{booking?.data?.host_about_me} </span>
              <h6
                className="btnnss"
                style={{ cursor: "pointer" }}
                onClick={handleMessageClick}
              >
                Message User
              </h6>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="chek_bx_txt">
                <div className="meddils">
                  <div
                    className="mg_arease"
                    onClick={() =>
                      navigate(
                        getExperienceUrl(
                          booking?.url_slug
                        )
                      )
                    }
                  >
                    <img
                      src={
                        booking?.host_images?.length > 0
                          ? `${baseUrl}${booking.host_images[0].image}`
                          : "/images/user_dh.png"
                      }
                      alt={booking.experience_title || "Experience"}
                      className="img-fluid"
                    />
                  </div>
                  <div className="dtls_rightss tetx_arease">
                    <h3
                      onClick={() =>
                        navigate(
                          getExperienceUrl(
                            booking?.url_slug
                          )
                        )
                      }
                    >
                      {booking.experience_title}
                    </h3>
                    <div className="us_listst">
                      <ul>
                        <li>
                          {booking.average_rating}{" "}
                          <i className="fa fa-star"></i>
                        </li>
                        <li
                          className={
                            booking.reviews_count > 0 ? "" : "platforma_cursor"
                          }
                          onClick={() => {
                            if (booking.reviews_count > 0) {
                              navigate(
                                getExperienceUrl(
                                  booking?.url_slug
                                )
                              );
                            }
                          }}
                        >
                          {booking.reviews_count || 0} reviews
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="ck_ckalsinss">
                    <div className="clk_liststs">
                      <h4>Date</h4>

                      <p>
                        {booking.booking_date},{" "}
                        {formatTimeTo12Hour(booking.booking_from_time)} -{" "}
                        {formatTimeTo12Hour(booking.booking_to_time)}
                      </p>
                    </div>
                    <div className="clk_liststs">
                      <h4>Booked By</h4>
                      <p>
                        {booking.user_first_name} {booking.user_last_name}
                      </p>
                    </div>
                  </div>

                  <div className="hst_us_txttx user_exprincess">
                    <div className="lft_txt">Key Highlights</div>
                    <div className="lft_txtrts">
                      {booking?.package_data && (
                        <div className="package-section mb-4 mt-3">
                          <h5 className="fw-bold mb-2">Package Details</h5>
                          <div className="package-info">
                            <p>
                              <strong>Title:</strong>{" "}
                              {booking.package_data.title}
                            </p>
                          </div>
                        </div>
                      )}

                      {booking?.itinerary?.length > 0 && (
                        <div className="hst_us_txttx">
                          <div className="lft_txt">Itinerary</div>
                          <div className="itinerary-grid">
                            {booking.itinerary.map((item, index) => (
                              <div
                                className="itinerary-card"
                                key={item.id || index}
                              >
                                <div
                                  className={`itinerary-info ${
                                    item.image ? "" : "images_booking"
                                  }`}
                                >
                                  <div className="mng_bothhhs">
                                    {item.image && (
                                      <div className="left_prtsss">
                                        <img
                                          src={`${baseUrl}${item.image}`}
                                          alt={item.activity_title}
                                          className="itinerary-img"
                                        />
                                      </div>
                                    )}
                                    <div className="right_prtsss">
                                      <h6>
                                        {item.activity_title || "Activity"}
                                      </h6>
                                      <p className="itinerary-place">
                                        {item.place}
                                      </p>
                                      <p className="itinerary-time">
                                        {formatTimeTo12Hour(item.activity_time)}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* <div className="map_bothss">
                    <div className="mgs_ar">
                      <img src="/images/hst_exest.jpg" alt="" />
                    </div>
                    <div className="maps">
                      <img src="/images/maps_hst.png" alt="" />
                    </div>
                  </div> */}
                  <div className="map_bothss">
                    <div
                      className="maps"
                      style={{ width: "100%", height: "300px" }}
                    >
                      {/* <iframe
      width="100%"
      height="100%"
      frameBorder="0"
      style={{ border: 0 }}
      src={`https://www.google.com/maps?q=${encodeURIComponent(
        `${booking.experience_house_no}, ${booking.experience_locality}, ${booking.experience_pin_code}`
      )}&output=embed`}
      allowFullScreen
      title="Experience Location"
    ></iframe> */}

                      <ExperienceMap
                        experienceData={booking}
                        house_no={booking?.experience_house_no}
                        locality={booking.experience_locality}
                        city={booking?.city_name}
                        country={booking?.country_name}
                      />
                    </div>
                  </div>

                  <div className="ck_ckalsinss host_exstet">
                    <div className="clk_liststs">
                      <h4>Cancellation Policy</h4>
                      {booking?.cancellation_policy ? (
    <div
      dangerouslySetInnerHTML={{ __html: booking.cancellation_policy }}
    />
  ) : (
    <p>No cancellation policy found.</p>
  )}
                    </div>

                    {/*<a href="">Download Invoice</a>
                      <a href="">Download Rules & Policies</a>*/}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="chek_bx_txtrigt">
                <div className="ck_ckalsinsses">
                  <div className="clk_liststs">
                    <h4>Payment Mode</h4>
                    <p>{booking.payment_method || "Credit Card"}</p>
                  </div>
                  <div className="clk_liststs">
                    <h4>Booking ID</h4>
                    <p>{booking.booking_id || "N/A"}</p>
                  </div>
                </div>

                <div className="hst_us_txttx couponbooking">
                  <h6>Price details</h6>

                  {/* Adult Price */}
                  {booking.guest_count > 0 && (
                    <p>
                      {booking.currency_symbol || "$"}
                      {Number(booking.price_per_guest || 0).toFixed(2)} ×{" "}
                      {booking.guest_count} adult
                      <span className="lasts">
                        {booking.currency_symbol || "$"}
                        {(
                          Number(booking.price_per_guest || 0) *
                          Number(booking.guest_count || 0)
                        ).toFixed(2)} {booking.currency || "AUD"}
                      </span>
                    </p>
                  )}

                  {/* Children Price */}
                  {booking.children_count > 0 && (
                    <p>
                      {booking.currency_symbol || "$"}
                      {Number(booking.price_per_child || 0).toFixed(2)} ×{" "}
                      {booking.children_count} child
                      <span className="lasts">
                        {booking.currency_symbol || "$"}
                        {(
                          Number(booking.price_per_child || 0) *
                          Number(booking.children_count || 0)
                        ).toFixed(2)} {booking.currency || "AUD"}
                      </span>
                    </p>
                  )}

                  {/* Infant Price */}
                  {booking.infants_count > 0 && (
                    <p>
                      {booking.currency_symbol || "$"}
                      {Number(booking.price_per_infant || 0).toFixed(2)} ×{" "}
                      {booking.infants_count} infant
                      <span className="lasts">
                        {booking.currency_symbol || "$"}
                        {(
                          Number(booking.price_per_infant || 0) *
                          Number(booking.infants_count || 0)
                        ).toFixed(2)} {booking.currency || "AUD"}
                      </span>
                    </p>
                  )}

                  {booking?.discount && booking?.coupon_code && (
                    <p className="d-flex justify-content-between text-success mt-2 coupon-discount-price">
                      <span>Discount {booking?.coupon_code ? `(${booking.coupon_code})` : ""}</span>
                      <span>
                       {booking.currency_symbol || "$"}{(booking?.discount)} {booking.currency || "AUD"}
                      </span>
                    </p>
                  )}

                  <h5>
                    Total Amount
                    <span className="lasts">
                      {booking.currency_symbol || "$"}
                      {Number(booking.total_price || 0).toFixed(2)}{" "}
                      {booking.currency || "AUD"}
                    </span>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ConfirmCancelModal
        show={showConfirm}
        onClose={() => setShowConfirm(false)}
        onConfirm={handleConfirmCancel}
        cancel_status={booking?.cancel_status}
        userType={2}
      />

      <PaymentLoadingModal isOpen={isCancelling} type="cancelling" />
    </>
  );
}

export default HostExperienceDetail;
